<template>
  <main-content with_go_back_bar>
    <kt-panel>
      <div class="create-services">
        <router-link to="/online-factor/discounts" class="mr-2">
          <button class="btn btn-success">بازگشت</button>
        </router-link>
      </div>
      <form
          v-if="discount"
          @submit.prevent="submitRequest"
          id="discount-form"
          class="kt-form p-3 my-4"
      >
        <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
          <kt-form-section is_first>
            <div class="section-header">
              کد تخفیف
            </div>
            <kt-row class="my-3 mx-4">
              <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                  <kt-form-label for="code">
                    {{ $t('online-factor.discount_code') }}
                    <span class="text-danger h5 pb-3">*</span>
                  </kt-form-label>
                  <input id="code" class="form-control" name="code" v-model="discount.code" style="text-transform: uppercase;">
                </kt-form-group>
              </kt-col>
              <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                  <kt-form-label for="discount_percent">
                    {{ $t('online-factor.discount_percent') }}
                    <span class="text-danger h5 pb-3">*</span>
                  </kt-form-label>
                  <input
                      type="number"
                      class="form-control"
                      step="0.01"
                      min="0"
                      max="100"
                      id="discount_percent"
                      name="discount_percent"
                      v-model="discount.discount_percent"
                  >
                </kt-form-group>
              </kt-col>
            </kt-row>
            <kt-row class="mx-4 my-4">
              <kt-col lg="12" md="12" xs="12" class="mt-4">
                <div class="d-flex">
                  <label class="form-check-label" for="min_purchase_amount_enable">تعیین حداقل مبلغ خرید</label>
                  <label class="switch mx-4">
                    <input
                        @click="min_purchase_amount_enable = !min_purchase_amount_enable"
                        type="checkbox"
                        id="min_purchase_amount_enable"
                        @change="discount.min_purchase_amount = 0"
                        v-model="min_purchase_amount_enable"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div
                    v-if="min_purchase_amount_enable"
                    class="d-flex flex-column"
                >
                  <input
                      type="number"
                      class="my-2 form-control col-lg-6 col-12"
                      id="min_purchase_amount"
                      name="min_purchase_amount"
                      v-model="discount.min_purchase_amount"
                  >
                  <span class="badge badge-light my-2 d-block w-25">
                    {{ Number(discount.min_purchase_amount).toLocaleString() + " ریال" }}
                  </span>
                  <div class="d-flex my-2 col-lg-6 col-12 px-0">
                    <i class="fa fa-info-circle fa-1x" style="color: darkred"></i>
                    <p class="mx-2 text-danger text-tiny">
                      کد تخفیف فقط برای فاکتور های بیشتر از این مبلغ قابل اعمال خواهد بود
                    </p>
                  </div>
                </div>
              </kt-col>
              <kt-col class="mt-4" lg="12" md="12" xs="12">
                <div class="d-flex">
                  <label class="form-check-label" for="max_discount_amount_enable">تعیین سقف مبلغ تخفیف</label>
                  <label class="switch mx-4">
                    <input
                        @click="max_discount_amount_enable = !max_discount_amount_enable"
                        type="checkbox"
                        id="max_discount_amount_enable"
                        @change="discount.max_discount_amount = 0"
                        v-model="max_discount_amount_enable"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div
                    v-if="max_discount_amount_enable"
                    class="d-flex flex-column"
                >
                  <input
                      type="number"
                      class="my-2 form-control col-lg-6 col-12"
                      id="min_discount_amount"
                      name="min_discount_amount"
                      v-model="discount.max_discount_amount"
                  >
                  <span class="badge badge-light my-2 d-block w-25">
                    {{ Number(discount.max_discount_amount).toLocaleString() + " ریال" }}
                  </span>
                  <div class="d-flex my-2 col-lg-6 col-12 px-0">
                    <i class="fa fa-info-circle fa-1x" style="color: darkred"></i>
                    <p class="mx-2 text-danger text-tiny">
                      حداکثر تخفیفی که با توجه به مبلغ محصول و درصد تخفیف تعیین شده، روی فاکتور اعمال خواهد شد
                    </p>
                  </div>
                </div>
              </kt-col>
            </kt-row>
            <kt-row class="mx-4 my-4">
              <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                  <kt-form-label for="expires_at">
                    {{ $t('online-factor.expires_at') }}
                  </kt-form-label>
                  <date-picker
                      v-model="discount.expires_at"
                      type="datetime"
                      name="expires_at"
                      color="#00c1a4"
                      display-format="dddd jDD jMMMM jYYYY HH:mm"
                      placeholder="YYYY-MM-DD"
                      id="expires_at"
                      clearable
                  />
                </kt-form-group>
              </kt-col>
            </kt-row>
            <kt-row class="mx-5 mt-5 mb-3">
              <button id="submit" class="btn btn-success" style="width: 100px">به روزرسانی</button>
            </kt-row>
          </kt-form-section>
        </div>
      </form>
    </kt-panel>
  </main-content>
</template>

<script>

import mainContent from '@/components/main-content.vue';
import { KTApp } from '@/plugins/core/app';
import { onlineFactorService } from '@/common/shop.service';
import toastr from 'toastr';
import $ from "jquery"

export default {
  name: 'CreateDiscount',
  components: {
    'main-content': mainContent,
  },
  data() {
    return {
      discount: null,
      discount_id: this.$route.params.hashid,
      max_discount_amount_enable: false,
      min_purchase_amount_enable: false
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
  },
  methods: {
    submitRequest() {
      let form = $('#discount-form')
      let btn = $('#submit')

      form.validate({
        ignore: ".ignore",
        rules: {
          code: {
            required: true
          },
          discount_percent: {
            required: true
          }
        }
      })

      if (!form.valid()) {
        return
      }

      KTApp.progress(btn)

      let data = {
        code: this.discount.code,
        discount_percent: this.discount.discount_percent,
      }

      data.min_purchase_amount = this.discount.min_purchase_amount
      data.max_discount_amount = this.discount.max_discount_amount
      data.expires_at = this.discount.expires_at

      onlineFactorService.updateDiscount(this.discount_id, data)
          .then(response => {
            this.toastr.success(response.data.message)
            this.$router.push('/online-factor/discounts')
          })
          .catch(({response}) => {
            for (let err in response.data.data) {
              this.toastr.error(response.data.data[err][0]);
            }
            this.toastr.error(response.data.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    }
  },
  watch: {
    discount_percent(value) {
      if (value < 0) this.discount_percent = 0;
      else if (value > 100) this.discount_percent = 100;
    }
  },
  mounted() {
    onlineFactorService.showDiscount(this.discount_id)
        .then(response => {
          this.discount = response.data.data
          this.max_discount_amount_enable = (this.discount.max_discount_amount !== 0)
          this.min_purchase_amount_enable = (this.discount.min_purchase_amount !== 0)
        })
  }
};
</script>

<style scoped>
.create-services {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
}

.text-tiny {
  font-size: 11px;
}
</style>